import { usePortalOpportunities } from "../portal/api.js";
import { OpportunityCard } from "../portal/OpportunityCard.js";

/**
 * My Quotes (unit 17): every invitation the contractor has quoted on,
 * newest first, with the outcome chip telling the story (open / won /
 * filled / closed). A filtered view of the dashboard list — one API call
 * serves all three tabs.
 */
export function PortalQuotes() {
  const { data, isPending } = usePortalOpportunities();

  if (isPending) {
    return (
      <div className="mx-auto max-w-md px-6 py-10">
        <div className="h-6 w-1/2 animate-pulse rounded bg-charcoal/15" />
        <div className="mt-4 h-24 animate-pulse rounded-2xl bg-charcoal/15" />
      </div>
    );
  }

  const quoted = (data?.items ?? []).filter((i) => i.quote !== null);

  return (
    <div className="mx-auto max-w-md px-4 py-8">
      <h1 className="px-2 text-xl font-bold text-charcoal">My quotes</h1>
      {quoted.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-charcoal/15 bg-white p-6 text-center">
          <p className="text-base text-charcoal">
            Quotes you send show up here with their outcomes.
          </p>
        </div>
      ) : (
        <div className="mt-4 space-y-3">
          {quoted.map((item) => (
            <OpportunityCard key={item.invitationId} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
